export enum ContentstackRegion {
  EUROPE = 'https://eu-graphql.contentstack.com',
  EUROPE_AZURE = 'https://azure-eu-graphql.contentstack.com',
  NORTH_AMERICA = 'https://graphql.contentstack.com', // Default region
  NORTH_AMERICA_AZURE = 'https://azure-na-graphql.contentstack.com',
}
